import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faFile, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

const DuplicateFileConfirmationModal = (props) => {
    const {
        openConfirmationModal = false,
        closeConfirmationModal = () => { },
        onSubmit = () => { },
        error = "",
        versionData,
        // existingFileName = "filename.txt"
    } = props;
    const existingFileName = versionData.name || "Filename"

    const [value, setValue] = useState("");

    const dialogFooter = (
        <div className="flex justify-content-end gap-2">
            <Button
                label="Cancel"
                icon="pi pi-times"
                onClick={closeConfirmationModal}
            />
            <Button
                label="Save & Replace"
                icon="pi pi-check"
                onClick={() => onSubmit(value)}
                autoFocus
            />
        </div>
    );

    return (
        <Dialog
            header={
                <div className="flex align-items-center gap-2">
                    <FontAwesomeIcon icon={faExclamationTriangle} className="text-yellow-500" />
                    <span className="font-bold">File Already Exists</span>
                </div>
            }
            visible={openConfirmationModal}
            onHide={closeConfirmationModal}
            footer={dialogFooter}
            className="p-fluid"
            // style={{ width: "450px" }}
            breakpoints={{ "960px": "75vw", "640px": "100vw" }}
            draggable={false}
            resizable={false}
        >
            <div className="text-center m-2">
                <span
                    className="m-0"
                    style={{
                        fontSize: "25px",
                        fontFamily: "roboto",
                        fontWeight: "700",
                        color: "black",
                    }}
                >
                    Do you want to replace it?
                </span>
                <p
                    className="text-600 m-0"
                    style={{
                        fontSize: "16px",
                        fontFamily: "roboto",
                        fontWeight: "700",
                    }}
                >
                    A file with this name already exists in this location.
                </p>
            </div>

            <div className="flex align-items-center justify-content-center mb-4 p-3 surface-100 border-round">
                <FontAwesomeIcon icon={"file-pdf"} className="mr-3 m-2" style={{ fontSize: "50px", color: "#e74c36" }} />
                <div className="text-left">
                    <p style={{ fontSize: "22px", fontFamily: "roboto", fontWeight: "700", color: "black" }}>{existingFileName}</p>
                </div>
            </div>

            <div className="field mb-4">
                <label
                    htmlFor="fileVersionNameFromBody"
                    className="block mb-2"
                    style={{ fontSize: "12px", fontWeight: "bold", color: "black" }}
                >
                    Provide the Version Filename for the previous file if required
                </label>

                <InputText
                    id="fileVersionNameFromBody"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="w-full"
                    placeholder="Enter version name (e.g., document_v2)"
                    autoFocus
                />

                <small className="p-error block mt-1">
                    {error && <span>{error}</span>}
                </small>
            </div>

            <div className="flex align-items-center gap-2 text-sm text-600 mt-4 pt-3 border-top-1 surface-border text-primary">
                <i className="pi pi-info-circle" style={{ fontSize: "20px" }}></i>
                <span style={{ fontFamily: "roboto", fontWeight: "500", fontSize: "15px" }}>The current file will be replaced, but the earlier version will remain accessible in version history.</span>
            </div>
        </Dialog>
    );
};

export default DuplicateFileConfirmationModal;
